import { render, staticRenderFns } from "./TestItem.vue?vue&type=template&id=5f8c925a&scoped=true"
import script from "./TestItem.vue?vue&type=script&lang=js"
export * from "./TestItem.vue?vue&type=script&lang=js"
import style0 from "./TestItem.vue?vue&type=style&index=0&id=5f8c925a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f8c925a",
  null
  
)

export default component.exports